import React from "react";
import { Link } from "gatsby";
import CustomImage from "../utilities/CustomImage";

const SingleSlide = ({ slide }) => {
  const {
    project: {
      document: { data: ProjectData, url },
    },
  } = slide;
  const { featured_image } = ProjectData;
  return (
    <Link
      to={url}
      className="embla__slide project-slide overflow-hidden  relative w-full h-full"
      title="embla slide"
    >
      <CustomImage
        image={featured_image}
        className="object-cover !max-h-full !max-w-full sm:!absolute max-sm:aspect-square top-0 left-0 !w-full !h-full"
      />
    </Link>
  );
};

export default SingleSlide;
